import { ManagerData } from 'api/types/data';
import { PersonalAccountEntity } from 'api/types/entity/personalAccountEntity';

import { AccountCodesFormType } from '../../forms/accountCodesForm';

interface Client {
  personalAccount: PersonalAccountEntity;
  code?: string;
  centralDepositoryAccountNumber?: string;
  centralDepositoryAccountNumberOpeningDate?: Date;
  manager?: ManagerData;
}

export const parseAccountCodesInitialValue = (client: Client) => {
  const values: AccountCodesFormType['accountCodes'] = {
    code: client.code ?? '',
    centralDepositoryAccountNumber: client.centralDepositoryAccountNumber ?? '',
    centralDepositoryAccountNumberOpeningDate:
      client.centralDepositoryAccountNumberOpeningDate ?? null,
    personalAccountNumber: client.personalAccount.number ?? '',
    personalAccountOpeningDate: client.personalAccount.openingDate ?? null,
    manager: client.manager ?? null,
    personalAccountClosingDate: client.personalAccount.closingDate ?? null,
    personalAccountFreezingDate: client.personalAccount.freezingDate ?? null,
  };

  return values;
};
